(function () {
  'use strict';

  const STORAGE_KEY = 'mndfrme-wishlist';
  const emptyState = () => ({ version: 2, items: [] });
  let memoryState = readState();

  function readState() {
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (Array.isArray(value)) return { version: 2, items: value.map((id) => ({ id: String(id) })) };
      if (value && value.version === 2 && Array.isArray(value.items)) return value;
    } catch (error) {
      return emptyState();
    }
    return emptyState();
  }

  function writeState(state) {
    memoryState = { version: 2, items: state.items };
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(memoryState)); } catch (error) {}
    document.dispatchEvent(new CustomEvent('mndfrme:wishlist-change', { detail: memoryState }));
  }

  function metadata(button) {
    return {
      id: String(button.dataset.productId || ''),
      handle: button.dataset.productHandle || '',
      url: button.dataset.productUrl || '',
      title: button.dataset.productTitle || '',
      price: button.dataset.productPrice || '',
      image: button.dataset.productImage || ''
    };
  }

  function hydrateFromCards() {
    let changed = false;
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const item = metadata(button);
      const index = memoryState.items.findIndex((saved) => saved.id === item.id);
      if (index >= 0 && !memoryState.items[index].handle) {
        memoryState.items[index] = item;
        changed = true;
      }
    });
    if (changed) writeState(memoryState);
  }

  function syncButtons() {
    const saved = new Set(memoryState.items.map((item) => item.id));
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const active = saved.has(String(button.dataset.productId || ''));
      button.classList.toggle('is-wishlisted', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function toggle(button) {
    const item = metadata(button);
    if (!item.id) return;
    const index = memoryState.items.findIndex((saved) => saved.id === item.id);
    if (index >= 0) memoryState.items.splice(index, 1);
    else memoryState.items.push(item);
    writeState(memoryState);
  }

  function escapeHtml(value) {
    const span = document.createElement('span');
    span.textContent = value || '';
    return span.innerHTML;
  }

  class MndfrmeWishlist extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.dialog = this.querySelector('[data-wishlist-dialog]');
      this.opener = this.querySelector('[data-wishlist-open]');
      this.list = this.querySelector('[data-wishlist-list]');
      this.empty = this.querySelector('[data-wishlist-empty]');
      this.count = this.querySelector('[data-wishlist-count]');
      this.lastFocus = null;
      this.opener.addEventListener('click', () => this.open());
      this.querySelector('[data-wishlist-close]').addEventListener('click', () => this.close());
      this.dialog.addEventListener('click', (event) => { if (event.target === this.dialog) this.close(); });
      this.dialog.addEventListener('close', () => this.restoreFocus());
      document.addEventListener('mndfrme:wishlist-change', () => this.render());
      this.render();
    }

    open() {
      this.lastFocus = document.activeElement;
      this.render();
      this.dialog.showModal();
      this.querySelector('[data-wishlist-close]').focus();
    }

    close() { this.dialog.close(); }
    restoreFocus() { if (this.lastFocus instanceof HTMLElement) this.lastFocus.focus(); }

    render() {
      const items = memoryState.items.filter((item) => item.handle && item.url);
      this.count.textContent = String(memoryState.items.length);
      this.count.hidden = memoryState.items.length === 0;
      this.empty.hidden = items.length > 0;
      this.list.innerHTML = items.map((item) => `
        <li class="mndfrme-wishlist__item">
          <a href="${escapeHtml(item.url)}" class="mndfrme-wishlist__image">${item.image ? `<img src="${escapeHtml(item.image)}" alt="" loading="lazy">` : ''}</a>
          <div><a href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a><span>${escapeHtml(item.price)}</span></div>
          <button type="button" data-wishlist-remove="${escapeHtml(item.id)}" aria-label="Remove ${escapeHtml(item.title)}">×</button>
        </li>`).join('');
      this.list.querySelectorAll('[data-wishlist-remove]').forEach((button) => {
        button.addEventListener('click', () => {
          memoryState.items = memoryState.items.filter((item) => item.id !== button.dataset.wishlistRemove);
          writeState(memoryState);
        });
      });
    }
  }

  function bindToggles(root = document) {
    root.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      if (button.dataset.wishlistReady === 'true') return;
      button.dataset.wishlistReady = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        toggle(button);
      });
    });
    hydrateFromCards();
    syncButtons();
  }

  if (!customElements.get('mndfrme-wishlist')) customElements.define('mndfrme-wishlist', MndfrmeWishlist);
  document.addEventListener('mndfrme:wishlist-change', syncButtons);
  document.addEventListener('DOMContentLoaded', () => bindToggles());
  document.addEventListener('shopify:section:load', (event) => bindToggles(event.target));
})();
